import { defineStore } from 'pinia';
import { ref } from 'vue';
import { DEFAULT_LOCALE } from '@/config/config';
import router from '@/router';

export const useLocaleStore = defineStore(
  'locale',
  () => {
    const locale = ref(DEFAULT_LOCALE);
    const supportedLocales = ref<string[]>([]);

    const setSupportedLocales = (locales: string[]) => {
      supportedLocales.value = locales;
    };

    const changeLocale = (newLocale: string) => {
      locale.value = newLocale;
      router.go(0); // refresh actual view to reload all data from API
    };

    return {
      locale,
      supportedLocales,

      setSupportedLocales,
      changeLocale,
    };
  },
  { persist: true },
);
